import React from 'react'
import './a2hs-modal.scss'
import GenericModal from '../generic-modal/generic-modal'
import Button from '../../atoms/button/button'

const A2hsModal = props => {
    const { setCommondModal, deferredPrompt } = props

    const mobile = window.innerWidth < 1024

    const closeModal = () => {
        setCommondModal(null)
    }

    const installPWA = () => {
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
            setCommondModal(null)
            localStorage.setItem('DENIED_A2HS', true)
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt');
            } else {
                console.log('User dismissed the A2HS prompt');
            }
            // setdeferredPrompt(null);
        });
    }

    const deniedInstallPWA = () => {
        if (localStorage.getItem('DENIED_A2HS') === null) {
            localStorage.setItem('DENIED_A2HS', false)
            closeModal()
        } else if (localStorage.getItem('DENIED_A2HS') === 'false') {
            localStorage.setItem('DENIED_A2HS', true)
            closeModal()
        }
    }

    return (
        <GenericModal>
            <span
                onClick={() => deniedInstallPWA()}
                className="icon2-close f-close-icon"
            />
            <div className="f-a2hs-modal-container">
                <span className="f-a2hs-modal-title">¿Quieres llevar el contenido de</span>
                <span className="f-a2hs-modal-subtitle">NOSOTRAS EN TU {mobile ? 'CELULAR' : 'COMPUTADOR'}?</span>
                <p className="f-a2hs-modal-description">Si aceptas se creará un acceso de NosotrasOnline en tu {mobile ? 'pantalla de inicio ' : 'escritorio '}para que ingreses a él cuando quieras.</p>
                <div className="f-button-container" onClick={() => installPWA()}>
                    <Button
                        className="primary-pink"
                        title="Me encantaría"
                    />
                </div>
                <span
                    className="f-alter-button"
                    onClick={() => deniedInstallPWA()}
                >
                    Por ahora no
                </span>
            </div>
        </GenericModal>
    )
}

export default A2hsModal
